<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      width="640px"
      :close-on-click-modal="false"
      class="app-main-inner unlock-apply-dialog"
    >
      <div slot="title" class="header-title">
        <span style="line-height: 24px;font-size: 18px;color: #333333;">{{ $t('SeaExport.UnlockApplyTitle') }}</span>
      </div>
      <!-- 提交中在弹窗内容区正中显示 loading 遮罩（而非按钮内转圈图标） -->
      <div v-loading="submitting">
        <div style="margin-bottom: 10px;font-size: 14px;">
          {{ $t('SeaExport.UnlockApplyJobCount', [selectedJobs.length]) }}
          <span style="color: #909399;">（{{ $t('SeaExport.UnlockApplyCountLimitTip') }}）</span>
        </div>
        <el-table :data="selectedJobs" border size="mini" max-height="200" style="margin-bottom: 15px;">
          <el-table-column
            :label="$t('SeaExport.BusinessNo')"
            prop="jobNo"
            min-width="140"
            show-overflow-tooltip
          />
          <el-table-column
            :label="$t('SeaExport.ConsignationCompany')"
            min-width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ customerName(scope.row) }}</template>
          </el-table-column>
        </el-table>
        <el-form ref="unlockApplyForm" :model="form" :rules="rules" label-width="130px" size="small">
          <el-form-item :label="$t('SeaExport.UnlockApplyReason')" prop="reason">
            <el-input
              v-model="form.reason"
              type="textarea"
              :rows="4"
              maxlength="500"
              show-word-limit
              :placeholder="$t('SeaExport.UnlockApplyReasonPlaceholder')"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DeclaredProfitImpact')" prop="declaredProfitImpact">
            <el-input-number
              v-model="form.declaredProfitImpact"
              :precision="2"
              :controls="false"
              style="width: 100%"
            />
          </el-form-item>
        </el-form>
        <div v-if="failures.length > 0">
          <div style="margin-bottom: 5px;color: #F56C6C;font-size: 14px;">{{ $t('SeaExport.UnlockApplyPrecheckFailed') }}</div>
          <el-table :data="failures" border size="mini" max-height="200">
            <el-table-column
              :label="$t('SeaExport.BusinessNo')"
              prop="jobNo"
              min-width="140"
              show-overflow-tooltip
            />
            <el-table-column
              :label="$t('SeaExport.UnlockApplyFailureReason')"
              prop="reason"
              min-width="220"
              show-overflow-tooltip
            />
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="submitting" @click="toSubmit">{{ $t('SeaExport.UnlockApplySubmit') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { applyUnlockApply } from '@/api/booking/unlockApply'

// 单次申请订单数量上限（与后端 590503 校验一致）
const MAX_APPLY_JOB_COUNT = 200

export default {
  name: 'UnlockApplyDialog',
  props: {
    visible: { type: Boolean, required: true },
    selectedJobs: { type: Array, default: () => [] }
  },
  data() {
    const validateReason = (rule, value, callback) => {
      if (!value || !value.trim()) {
        callback(new Error(this.$t('SeaExport.UnlockApplyReasonRequired')))
      } else if (value.length > 500) {
        callback(new Error(this.$t('SeaExport.UnlockApplyReasonOverLength')))
      } else {
        callback()
      }
    }
    const validateProfitImpact = (rule, value, callback) => {
      if (value === undefined || value === null || value === '') {
        callback(new Error(this.$t('SeaExport.UnlockApplyAmountRequired')))
      } else {
        callback()
      }
    }
    return {
      innerVisible: false,
      submitting: false,
      failures: [],
      form: {
        reason: '',
        declaredProfitImpact: undefined
      },
      rules: {
        reason: [{ required: true, validator: validateReason, trigger: 'blur' }],
        declaredProfitImpact: [{ required: true, validator: validateProfitImpact, trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.resetForm()
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    resetForm() {
      this.form.reason = ''
      this.form.declaredProfitImpact = undefined
      this.failures = []
      this.submitting = false
      this.$nextTick(() => {
        if (this.$refs.unlockApplyForm) {
          this.$refs.unlockApplyForm.clearValidate()
        }
      })
    },
    // 客户名称：列表行数据仅含 customerId，按基础资料缓存解析（同列表页客户列口径）
    customerName(row) {
      if (!row || !row.customerId) return ''
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(row.customerId), 'chineseName')
    },
    toSubmit() {
      if (this.selectedJobs.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (this.selectedJobs.length > MAX_APPLY_JOB_COUNT) {
        this.$message.warning(this.$t('SeaExport.UnlockApplyOverLimit'))
        return
      }
      this.$refs.unlockApplyForm.validate(valid => {
        if (!valid) return
        this.submitting = true
        const jobUuids = this.selectedJobs.map(job => job.uuid)
        applyUnlockApply({
          jobUuids,
          reason: this.form.reason.trim(),
          declaredProfitImpact: this.form.declaredProfitImpact
        }).then(res => {
          this.submitting = false
          const batchNo = res.data && res.data.batchNo
          this.$message.success(this.$t('SeaExport.UnlockApplySubmitted', [batchNo]))
          this.innerVisible = false
          this.$emit('success', batchNo)
        }).catch(err => {
          this.submitting = false
          this.failures = this.parseFailures(err)
          if (this.failures.length === 0) {
            const message = (err && (err.errorMsg || err.message)) || err
            this.$message.error(typeof message === 'string' ? message : this.$t('SeaExport.UnlockApplyPrecheckFailed'))
          }
        })
      })
    },
    // 解析后端逐单失败原因（兼容 data 数组与 errors.message 逐行文本两种结构，文案形如"JOB001：应收/应付费用均未锁定"）
    parseFailures(err) {
      const texts = []
      const data = err && err.data
      if (Array.isArray(data)) {
        for (const item of data) {
          if (typeof item === 'string') {
            texts.push(item)
          } else if (item && typeof item === 'object' && item.message) {
            texts.push(item.message)
          }
        }
      }
      const errors = (err && err.errors) || []
      for (const error of errors) {
        if (error && error.message) {
          const lines = String(error.message).split(/[\n\r]+/)
          for (const line of lines) {
            if (line.trim()) texts.push(line.trim())
          }
        }
      }
      const failures = []
      for (const text of texts) {
        const separatorIndex = text.search(/[：:]/)
        if (separatorIndex > 0) {
          failures.push({ jobNo: text.substring(0, separatorIndex), reason: text.substring(separatorIndex + 1).trim() })
        } else {
          failures.push({ jobNo: '', reason: text })
        }
      }
      return failures
    }
  }
}
</script>

<style scoped>
/* 仅本弹窗：字段间距常驻预留校验红字空间，校验前后布局保持稳定不跳动
   （!important 用于对抗 layout 中带 ID 的全局 8px 压制规则，作用域仅限本弹窗） */
.unlock-apply-dialog ::v-deep .el-form-item {
  margin-bottom: 24px !important;
}
/* 最后一个字段下方是弹窗 footer，无需预留红字空间，保持原有紧凑间距 */
.unlock-apply-dialog ::v-deep .el-form-item:last-child {
  margin-bottom: 8px !important;
}
/* 红字文档流内渲染在字段正下方，负 margin 抵消自身占位（红字高 16px = 4px padding + 12px 文字），显示在上方预留的间距内 */
.unlock-apply-dialog ::v-deep .el-form-item__error {
  position: static;
  margin-bottom: -16px;
}
</style>
